import styled from 'styled-components';

import Icon from 'components/Icon';
import Paragraph from 'components/Paragraph';
import Button from 'components/Button';

export const Wrapper = styled.article`
  border: 1px solid ${props => props.theme.color.wfGrey200};
  border-top: 0;
  display: inline-block;
  padding: ${props =>
    `${props.theme.spacing.default} ${props.theme.spacing.xlarge} ${props.theme.spacing.xxlarge}`};
  background-color: ${props => props.theme.color.wfWhite};
  display: flex;
  flex-direction: column;
  position: relative;
  box-shadow: 0 ${props => props.theme.spacing.default} 0 0
    ${props => props.theme.color[props.color] || props.theme.color.wfBlack}
    inset;
`;

export const ButtonStyled = styled(Button)`
  margin: auto 0 ${props => props.theme.spacing.medium};
  align-self: center;
`;

export const ParagraphStyled = styled(Paragraph)`
  line-height: 1;
  position: absolute;
  left: 0;
  bottom: ${props => props.theme.spacing.xlarge};
  width: 100%;
  text-align: center;
`;

export const IconStyled = styled(Icon)`
  vertical-align: top;
  margin-left: ${props => props.theme.spacing.small};
  cursor: pointer;
`;
